<template>
  <v-card v-if="project && email">
    <v-card-title>
      <v-avatar size=48>
        <v-icon color="primary" large>link</v-icon>
      </v-avatar>
      <span class="subheading text-uppercase pl-2 pr-2">
        Manage ticket links
      </span>
    </v-card-title>

    <v-card-text>
      <v-layout class="mb-3">
        <v-flex>
          <v-layout>
            <v-flex xs10 class="text-capitalize text-uppercase">
              Ticket
            </v-flex>
            <v-flex xs2 class="text-capitalize text-uppercase">
              Linked
            </v-flex>
          </v-layout>
          <v-divider/>
        </v-flex>
      </v-layout>

      <v-layout row class="mb-3" v-show="linkedTickets.length == 0">
        <v-flex>
        There are no tickets linked
        </v-flex>
      </v-layout>

      <v-layout v-for="(linkedTicket, idx) in linkedTickets" :key="idx" row class="mb-3">
        <v-flex>
          <v-layout>
            <v-flex xs10>
              <v-chip small disabled outline>
                {{linkedTicket.attributes.sequential_id}}
              </v-chip>
              {{linkedTicket.attributes.title}}
            </v-flex>
            <v-flex xs2>
              <v-switch class="mt-0 pt-0" v-model="linkedTicket.linked"></v-switch>
            </v-flex>
          </v-layout>
          <v-divider/>
        </v-flex>
      </v-layout>

      <v-form ref="form" lazy-validation>
        <v-layout>
          <v-flex xs9>
            <v-combobox
              class="xs10"
              v-model="localTicket"
              :items="tickets"
              label="Link to another ticket"
              item-text="attributes.title"
              no-filter
              clearable
              :search-input.sync="pagination.search"
              >
              <template v-slot:selection="{ item, parent, selected}">
                <v-chip small disabled outline v-if="item.attributes">
                  {{item.attributes.sequential_id}}
                </v-chip>
                <span v-if="item.attributes">
                  {{item.attributes.title}}
                </span>
              </template>
              <template v-slot:item="{ index, item}">
                <v-chip small disabled outline v-if="item.attributes">
                  {{item.attributes.sequential_id}}
                </v-chip>
                <span v-if="item.attributes">
                  {{item.attributes.title}}
                </span>
              </template>
            </v-combobox>
          </v-flex>
          <v-flex xs2 offset-xs1>
            <v-btn color="success" @click="linkTicket()" :disabled="!localTicket" :loading="busy"><v-icon class="pr-2">link</v-icon>Link</v-btn>
          </v-flex>
        </v-layout>

      </v-form>
      <v-layout>
        <v-flex xs12>
          <v-alert :value="true" color="info" icon="info" outline class="text-xs-left">A ticket can only be linked to a one email. This selection will only show unlinked tickets.</v-alert>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="cancel()">Cancel</v-btn>
      <v-btn color="primary" @click="processLinks()" :loading="busy">Update Links</v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>
  import { debounce } from 'debounce'
  import { EventBus } from '@/utilities/event-bus'
  import authentication from '@/utilities/authentication'

  import ticketService from '@/services/ticket'

  export default {
    name: 'ticket-link',

    props: ['project', 'email'],

    data () {
      return {
        auth: authentication,
        localTicket: null,
        tickets: [],
        linkedTickets: [],
        busy: false,
        rules: {
          required: value => !!value || 'Required'
        },
        pagination: {
          rowsPerPage: parseInt(authentication.preferences().page_size) || 5,
          sortBy: (authentication.preferences().ticket_sort_by || 'created_at'),
          descending: !(authentication.preferences().ticket_sort_order === 'asc'), // This is to deal with the preference being unset
          search: ''
        }
      }
    },

    components: {
    },

    computed: {
    },

    watch: {
      pagination: {
        handler (val) {
          if (val.search) {
            this.reloadTickets()
          }
        },
        deep: true
      }
    },

    mounted () {
      this.loadLinkedTickets()
    },

    methods: {
      cancel () {
        this.localTicket = null
        this.linkedTickets = []
        this.$nextTick(() => {
          EventBus.$emit('ticket-linked')
        })
      },

      reloadTickets: debounce(function () {
        this.loadTickets()
      }, 1000),

      loadTickets () {
        ticketService.projectIndexUnlinked(
          (data) => {
            this.tickets = data
          },
          (err) => {
            console.log(err)
          },
          this.project.id,
          this.pagination
        )
      },

      loadLinkedTickets () {
        ticketService.emailIndex(
          (data) => {
            this.linkedTickets = data
            // Set a helper attribute to control the toggle
            for (let link of this.linkedTickets) {
              link.linked = true
            }
          },
          (err) => {
            console.log(err)
          },
          this.project.id,
          this.email.id
        )
      },

      linkTicket () {
        this.localTicket.linked = true
        this.linkedTickets.push(Object.assign({}, this.localTicket))
        this.localTicket = {}
      },

      async processLinks () {
        this.busy = true
        if (this.$refs.form.validate()) {
          for (let ticket of this.linkedTickets) {
            if (ticket.linked) {
              ticket.attributes.email_id = this.email.id
              await this.updateTicket(ticket.attributes)
              EventBus.$emit('ticket-linked', ticket)
            } else {
              ticket.attributes.email_id = null
              await this.updateTicket(ticket.attributes)
              EventBus.$emit('ticket-unlinked', ticket)
            }
          }
        }
        this.busy = false
      },

      updateTicket (ticket) {
        return ticketService.update(
          (data) => {
          },
          (err) => {
            console.log(err)
          },
          ticket
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/email/_link.vue